import { Controller } from "stimulus"
import $ from 'jquery'
import 'datatables.net-bs4'

export default class extends Controller {
  connect() {
    $(this.element).DataTable({
      retrieve: true, // Reconnect to existing instance
      paging: true, // Enable pagination
      searching: true, // Enable searching
      order: [[0, "desc"]], // Order by created_at, newest first
      pageLength: 25, // Set the number of rows per page
      autoWidth: false,
      columnDefs: [
        { targets: '_all', width: '1%', createdCell: function(td) { td.style.width = '1px'; td.style.whiteSpace = 'nowrap'; td.style.maxWidth = 'max-content'; } }
      ]
    });
  }
}
